/**
 * 広告ネットワーク定義レジストリ
 *
 * 新しいネットワークを追加する場合はここにエントリを追加するだけでよい。
 * varuna DB / API / UI への反映はすべて自動的に行われる。
 *
 * 各フィールド:
 *   id          - DB・Cookie のキーになる一意な識別子（英小文字）
 *   label       - マイページの設定項目に表示する名称
 *   description - トグル下に表示する説明文
 *   envKey      - PixelID を格納する環境変数名（VUE_APP_XXX）
 *   fire()      - 同意後に呼び出すタグ発火関数
 *   fireLead()  - CV（Lead）イベント発火関数
 */

/**
 * タグ発火のマスタースイッチ。
 *
 * 同意状態の蓄積のみ行い、実際のタグ発火はさせないフェーズでは false のままにする。
 * 発火を有効化する場合のみ、環境変数 VUE_APP_AD_FIRING_ENABLED=true を設定する。
 *
 * ※ ネットワーク個別の Pixel ID 設定（envKey）とは独立した、
 *   「発火してよいか」を明示的に制御する安全ゲート。ID の設定漏れに依存しない。
 */
export const AD_FIRING_ENABLED = process.env.VUE_APP_AD_FIRING_ENABLED === 'true'

export const AD_NETWORKS = [
  {
    id: 'meta',
    label: 'Meta（Facebook）広告',
    description: 'Meta広告の最適化に利用状況を使用',
    envKey: 'VUE_APP_META_PIXEL_ID',
    fire () {
      const pixelId = process.env.VUE_APP_META_PIXEL_ID
      if (!pixelId) return
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'PageView')
        return
      }
      ;(function (f, b, e, v, n, t, s) {
        if (f.fbq) return
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        }
        if (!f._fbq) f._fbq = n
        n.push = n; n.loaded = true; n.version = '2.0'; n.queue = []
        t = b.createElement(e); t.async = true; t.src = v
        s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
      window.fbq('init', pixelId)
      window.fbq('track', 'PageView')
    },
    fireLead () {
      if (typeof window.fbq === 'function') window.fbq('track', 'Lead')
    },
  },

  // ── 追加例（コメントアウト中） ──────────────────────────────────────
  // {
  //   id: 'tiktok',
  //   label: 'TikTok広告',
  //   description: 'TikTok広告の最適化に利用状況を使用',
  //   envKey: 'VUE_APP_TIKTOK_PIXEL_ID',
  //   fire () { /* ttq.track('PageView') */ },
  //   fireLead () { /* ttq.track('SubmitForm') */ },
  // },
  // {
  //   id: 'line',
  //   label: 'LINE広告',
  //   description: 'LINE広告の最適化に利用状況を使用',
  //   envKey: 'VUE_APP_LINE_PIXEL_ID',
  //   fire () { /* _lt('send', 'pv', [...]) */ },
  //   fireLead () { /* _lt('send', 'cv', [...]) */ },
  // },
]

/** id から定義を取得するヘルパー */
export function getNetworkById (id) {
  return AD_NETWORKS.find(n => n.id === id) || null
}
